import { useServices } from "@/services/hooks/useServices";
import { DashboardStatistics } from "@/types/dashboard.types";
import { useQuery } from "@tanstack/react-query";

export const useGetDashboardStatistics = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}) => {
  const { dashboardService } = useServices();

  return useQuery<DashboardStatistics>({
    queryKey: ["dashboard-statistics", { startDate, endDate }],
    queryFn: () => dashboardService.getDashboardStatistics(startDate, endDate),
    refetchOnWindowFocus: false,
  });
};
